import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { pageInitDisplay } from '../utils/globalUtils';
import { getUserTopics } from '../utils/api-services/topic';
import PageLoader from '../global/components/PageLoader';
import UserTopicItem from './components/UserTopicItem';

function UserTopics() {

    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState("init");

    useEffect(()=>{
        loadTopics("", "");
    }, []);

    const loadTopics = async (page, query) => {
        setLoading("loading");
        const data = await getUserTopics(page, query);
        setTopics(data);
        setLoading("completed");
    }

    const styles = {
        page:{
            paddingTop: 40,
            paddingBottom: 100
        },
        header:{
            paddingBottom: 30,
            display: 'flex',
            alignItems: 'center'
        },
        title: {
            color: '#666',
            fontSize: 18
        },
        newTopicBtn:{
            marginLeft: 'auto',
            marginRight: 0
        },
    }

    const topicsDisplay = (
        <div style={styles.page}>
        <div className='container'>
            <div className='row'>
                <div className='col-md-3'></div>
                <div className='col-md-8'>

                    <div style={styles.header}>
                        <h4 style={styles.title}>Topics</h4>
                        <div style={styles.newTopicBtn}>
                            <Link to={"/topic/new"} className='btn btn-sm btn-primary'>
                                <FontAwesomeIcon icon={faPlus} /> Create New Topic
                            </Link>
                        </div>
                    </div>
                    
                    <div>
                        {topics.map(itm=>(
                            <UserTopicItem key={itm.Id} obj={itm} />
                        ))}
                    </div>

                </div>
            </div>
        </div>
        </div>
    )

    const initDisplay = (
        <div style={styles.page}>
            {pageInitDisplay({
                icon: '/images/bulb.png',
                title: 'Create your first topic',
                info: 'Topics helps you share knowledge with others',
                url: '/topic/new',
                label: 'Create New Topic',
                btnIcon: faPlus
            })}
        </div>
    )

    if(loading == "init"){
        return (
            <div style={{marginTop:120,marginBottom:30}}>
                <PageLoader />
            </div>
        )
    }
    else if(loading == "completed"){
        return (
            <div>
                {(topics.length > 0)? topicsDisplay: initDisplay}
            </div>
        )
    }
    
}

export default UserTopics;